/* tslint:disable */
/* eslint-disable */
/**
 * Coupon Service
 * Coupon Service API Docs
 *
 * The version of the OpenAPI document: v1
 * Contact: info@mrbilit.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const Providers = {
    NUMBER_0: 0,
    NUMBER_3: 3
} as const;

export type Providers = typeof Providers[keyof typeof Providers];



